class Notifications {
    constructor( ctx ) {
        this.ctx = ctx;
        this.hide = this.hide.bind( this );
    }

    /**
     * @param {String} msg the message to display
     * @param {Object} options options to configure the message displaying, see the example for available options.
     * @example
     * notify( 'Hello, World!', {
     *     autohide: Boolean, // whether to automatically hide the message
     *     autohideAfter: Number, // time in ms to hide the message after
     *     block: Boolean // whether the message will block other messages from displaying
     * } );
     * @returns void
     */
    notify( notificationID, msg, options = {} ) {
        options = Object.assign( {}, this.defaults, options );

        this.messageContainer.innerHTML = msg;
        this.messageContainer.dataset.notificationId = notificationID;

        if ( this.container.dataset.block === 'true' ) {
            return;
        }

        this.container.querySelectorAll( 'button[data-for-notification]' ).forEach( ( btn ) => btn.remove() );

        if ( options.btn && typeof options.btn === 'function' ) {
            const buttonToAdd = options.btn( this );
            this.container.appendChild( buttonToAdd );
        }

        this.container.dataset.block = options.block || false;

        this.container.classList.add( 'open' );

        if ( options.autohide ) {
            window.setTimeout( this.hide.bind( this ), options.autohideAfter );
        }
    }

    hide() {
        this.messageContainer.innerHTML = '';

        this.container.querySelectorAll( 'button[data-for-notification]' ).forEach( ( btn ) => btn.remove() );

        this.messageContainer.dataset.notificationId = '';
        this.container.dataset.block = false;
        this.container.classList.remove( 'open' );
    }

    handleNotificationEvent( event ) {
        const { id, msg, options } = event.detail;
        this.notify( id, msg, options );
    }

    handleNotificationCloseEvent( event ) {
        const { notifiationID } = event.detail;

        if ( notifiationID && this.messageContainer.dataset.notifiationId !== notifiationID ) {
            return;
        }

        this.hide();
    }

    onAdd( map ) {
        this.map = map;

        this.container = document.createElement( 'aside' );
        this.container.id = 'twc__map-search-messagecontainer';

        this.messageContainer = document.createElement( 'div' );
        this.container.appendChild( this.messageContainer );

        this.ctx.root.addEventListener( 'twc:mapsearch:show-notification', this.handleNotificationEvent.bind( this ) );

        this.ctx.root.addEventListener( 'twc:mapsearch:hide-notification', this.hide.bind( this ) );

        return this.container;
    }

    get defaults() {
        return {
            autohide: true,
            autohideAfter: 3000,
            btn: null,
        };
    }
}

export default Notifications;
